import script from "./RealEstateOwners.vue?vue&type=script&setup=true&lang=js"
export * from "./RealEstateOwners.vue?vue&type=script&setup=true&lang=js"

import "./RealEstateOwners.vue?vue&type=style&index=0&id=79c81fac&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79c81fac"]])

export default __exports__